var a = /* @__PURE__ */ ((r) => (r.Market = "Market", r.Location = "Location", r.Practice = "Practice", r))(a || {}), o = /* @__PURE__ */ ((r) => (r.Corporate = "Corporate", r.Hospital = "Hospital", r.Physician = "Physician", r.MHO = "MHO", r.UrgentCare = "UrgentCare", r))(o || {});
export {
  a as M,
  o as S
};
